import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import { ServicesDialog } from './services.dialog';
import { Customer } from '../../models/customer';
import { Icons } from '../../assets/icons';
import { GridCountCell } from '../../components/grid-cell-count';
import { UserPermissionName } from '../../models/user-permission-name';
import { useAuthorize } from '../../hooks/use-authorize';

interface CustomGridCellProps {
  field: string;
}

interface CellProps {
  customer: Customer;
}

const ServicesCountCell = ({ customer }: CellProps) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const dialogHandler = () => {
    setIsDialogVisible(!isDialogVisible);
  };

  const isServiceViewPermission = useAuthorize([UserPermissionName.VIEW_SERVICE_CUSTOMER]);

  return (
    <>
      <GridCountCell
        count={customer.servicesCount}
        icon={<DescriptionOutlinedIcon className="serviceImgIcon" />}
        onClick={dialogHandler}
        isDisabled={!isServiceViewPermission}
      />
      {isDialogVisible && (
        <ServicesDialog customerID={customer.customerID} isOpen={isDialogVisible} onCloseClick={dialogHandler} />
      )}
    </>
  );
};

export const CustomGridCell = ({ field }: CustomGridCellProps) => {
  const isProjectViewPermission = useAuthorize([UserPermissionName.VIEW_PROJECT]);

  if (field === 'projectsCount') {
    return ({ dataItem }: any) => {
      return (
        <GridCountCell
          count={dataItem.projectsCount}
          icon={<img src={Icons.Project} alt="Project" className="gridImgMaxHeight" />}
          route={`/projects?customerID=${dataItem.customerID}`}
          isDisabled={!isProjectViewPermission}
        />
      );
    };
  }
  if (field === 'servicesCount') {
    return (dataItem: any) => {
      return <ServicesCountCell customer={dataItem.dataItem} />;
    };
  }
};
